__webpack_require__.p = "./wp-content/plugins/anslagstavlan/frontend/build/";